import remote from './remote'

const URL = {
    GET: '/cms/help'
}

export default {
    getCmsHelp () {
        return remote.request({
            url: remote.getUrl(URL.GET)
        })
    }
}
